/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
/**
 * 新创建对象前面的标记
 */
export const NEW_TAG = 'New';

/**
 * 智能助手宽度
 */
export const ASSISTANT_WIDTH = '416px';

/**
 * 未开启助手时，主页面的宽度
 */
export const FULL_WIDTH = '100%';

/**
 * 极简模式左侧菜单宽度
 */
export const SIMPLE_LEFT_MENU_WIDTH = {
    /**
     * 小屏收起状态
     */
    MIN: '48px',
    /**
     * 大屏展开状态
     */
    MAX: '256px',
};
